import { UnidadeGestora } from './unidade-gestora';
import { DomainSerializer } from '../../../common/domain.serializer';

export class UnidadeGestoraSerializer extends DomainSerializer<UnidadeGestora> {
}
